import { GiftcardPaymentInfo, PaymentInfo } from '@repo/types';

export function isGiftcardPaymentInfo(
    paymentInfo: PaymentInfo | GiftcardPaymentInfo,
): paymentInfo is GiftcardPaymentInfo {
    return (paymentInfo as GiftcardPaymentInfo).giftcard !== undefined;
}
